// src/components/ProductCarousel.jsx
import React from "react";
import Slider from "react-slick";
import { Dialog } from "@headlessui/react";
import { X } from "lucide-react";
import { useState, useRef } from "react";

const ProductCarousel = ({ images }) => {

  const sliderRef = useRef(null); // REF to control the slider

  const hasMultipleImages = images.length > 1;
  
  const settings = {
    dots: hasMultipleImages,
    infinite: hasMultipleImages,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: hasMultipleImages ? true : false,
    autoplaySpeed: 2000,
    arrows: false,
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const openModal = (index) => {
    setSelectedIndex(index);
    setIsModalOpen(true);
    // --- Pause autoplay when modal opens ---
    if (sliderRef.current) sliderRef.current.slickPause();
  };

  const closeModal = () => {
    setIsModalOpen(false);
    // --- Resume autoplay when modal closes ---
    if (sliderRef.current) sliderRef.current.slickPlay();
  };

  const nextImage = () => {
    setSelectedIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setSelectedIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <>
      {/* Conditionally render Slider or a single img tag */}
      {hasMultipleImages ? (
        <Slider {...settings} ref={sliderRef}>
          {images.map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`product ${index}`}
              className="rounded-lg w-full h-48 object-cover cursor-pointer"
              onClick={() => openModal(index)}
            />
          ))}
        </Slider>
      ) : (
        // Render a single image directly if there's only one
        images.length > 0 && ( // Ensure there's at least one image to display
          <img
            src={images[0]} // Display the first (and only) image
            alt={`product 0`}
            className="rounded-lg w-full h-48 object-cover cursor-pointer"
            onClick={() => openModal(0)} // Open modal with the first image
          />
        )
      )}
    <Dialog open={isModalOpen} onClose={closeModal} className="fixed inset-0 z-50 flex items-center justify-center bg-black/70">
      <div className="relative max-w-3xl w-full p-4">
        <img
          src={images[selectedIndex]}
          alt={`enlarged ${selectedIndex}`}
          className="w-full h-auto max-h-[80vh] object-contain rounded-lg"
        />
        {/* Close Button */}
        <button
          onClick={closeModal}
          className="absolute top-3 right-3 bg-white rounded-full p-2 shadow hover:bg-gray-200"
        >
          <X className="h-5 w-5 text-black" />
        </button>
        {/* Navigation Buttons */}
        {images.length > 1 && (
          <>
            <button
              onClick={prevImage}
              className="absolute left-2 top-1/2 -translate-y-1/2 bg-white rounded-full p-2 shadow hover:bg-gray-200"
            >
              ←
            </button>
            <button
              onClick={nextImage}
              className="absolute right-2 top-1/2 -translate-y-1/2 bg-white rounded-full p-2 shadow hover:bg-gray-200"
            >
              →
            </button>
          </>
        )}
      </div>
    </Dialog>
    </>
  );
};

export default ProductCarousel;
